import React from 'react'
import { Container } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
    footer: {
        textAlign: 'center',
        marginTop: 'auto',
        color: 'white',
        backgroundColor: '#222222',
        zIndex: 1,
    },
    footerTopBar: {
        padding: '1rem 0',
        textAlign: 'center',
    },
    footerBottomBar: {
        padding: '0 0 1rem 0',
    },
    footerLink: {
        color: 'white',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
}))

const Footer = (props) => {
    const classes = useStyles()
    return (
        <>
            <footer className={classes.footer}>
                <div className={classes.footerTopBar}>
                    <Container maxWidth="lg">
                        &copy; {new Date().getFullYear()} GiftCardGranny.com -
                        Telos Gifting LLC. &#124;{' '}
                        <a
                            className={classes.footerLink}
                            href={props.baseUrl + '/terms/'}
                        >
                            Terms of Service
                        </a>{' '}
                        &#124;{' '}
                        <a
                            className={classes.footerLink}
                            href={props.baseUrl + '/privacy-policy/'}
                        >
                            Privacy Policy
                        </a>{' '}
                    </Container>
                </div>
                <div className={classes.footerBottomBar}>
                    <Container maxWidth="lg">{props.content}</Container>
                </div>
            </footer>
        </>
    )
}

export default Footer
